import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.paymentMethodSection.title',
    defaultMessage: 'Payment method',
    description: 'title of the payment method section',
  },
  overview: {
    paymentMethod: {
      id: 'properties.paymentMethod',
      defaultMessage: 'Payment method',
      description: 'label of the payment method property',
    },
    paymentIssuer: {
      id: 'properties.paymentMethodIssuer',
      defaultMessage: 'Bank',
      description: 'label of the payment method issuer property',
    },
    paymentProvider: {
      id: 'properties.paymentProvider',
      defaultMessage: 'Payment provider',
      description: 'label of the payment provider property',
    },
  },
};

export default defineMessages(translations);
